module.exports = __webpack_public_path__ + "static/media/phenom_logo.1417224b.png";